import { configureStore } from '@reduxjs/toolkit';
import { activitiesService } from './activities/activitiesService';
import { daysOffService } from './daysOff/daysOffService';
import { reportsService } from './reports/reportsService';
import { persistedReducer } from './rootReducer';
import { reportsActivitiesService } from './reports/reportsActivitiesService';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistStore,
} from 'redux-persist';
import { employeesService } from './employees/employeesService';
import { projectsService } from './projects/projectsService';
import { towersService } from './towers/towersService';
import { tasksService } from './tasks/tasksService';

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      daysOffService.middleware,
      activitiesService.middleware,
      reportsActivitiesService.middleware,
      reportsService.middleware,
      employeesService.middleware,
      projectsService.middleware,
      towersService.middleware,
      tasksService.middleware,
    ]),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
